import script from "./PDPLink.vue?vue&type=script&lang=ts"
export * from "./PDPLink.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__